import { BCMSRecord, BCMSStateManagerCRUD, DisabledPrompt, useBCMSContext, useRoute } from "@bcm-dev/bcms-vite";
import UIRadioGroup, { UIRadio } from "components/custom-ui/UIRadioGroup";
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { PrimaryButton, SecondaryButton } from "components/ui";
import Classes, { TaxDocument } from "model";
import "./styles.css";
import "./mobile.css";


/**
 * @function ChangeLanguagePage
 * @return {React.Component}
 * @exported true
 * @description The change language page.
 */
export default function ChangeLanguagePage(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    onProfilePickerChange: profileID => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "selectedProfileID" ], { id: profileID })
        .submit(setState);
    },

    onProfilePickerSelectClick: evt => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "taxDocuments" ], 
            TaxDocument.initAll().filter(item => item.profile.id === state.data.selectedProfileID.id)
        )
        .submit(setState);
    }
  });

  return (
    <PageContainer className="change-language-page" state={{ data, ui }} controller={ controller }>
      <PageContent />
    </PageContainer>
  );
}


export const getDefaultData = () => ({
  // no data for now.
});

export const getDefaultUI = () => ({
  // no data for now.
});

/**
 * @function PageContent
 * @return {React.Component}
 * @exported false
 * @description The content for the page.
 */
function PageContent(props) {
  const navigate = useRoute();

  return (
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Change Language" />
          <FormContainer className="small-form-width">
            <FormRowView text="Please select your desired language choice." className="participant-type-form-row">
              <UIRadioGroup value="english">
                  <UIRadio className="ui-group-item" label="English" value="english" />
                  <DisabledPrompt>
                    <UIRadio className="ui-group-item" label="Español" value="spanish" />
                  </DisabledPrompt>
              </UIRadioGroup>
            </FormRowView>
            <FormButtonRow>
              <SecondaryButton text="Cancel" onClick={ () => navigate("/settingsmenu") } />
              <DisabledPrompt>
                <PrimaryButton text="Update" />
              </DisabledPrompt>
            </FormButtonRow>
          </FormContainer>
        </CenterContentContainer>
      </PageContentView>  
  );
}

